import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import InterlinkingBlock from '../shared/InterlinkingBlock';
import messages from '../../../messages';

const { locationTitle, closeTo, citiesInRegion, propertyTypesIn, similarSearches } = messages;

class InterlinkingHomes extends React.PureComponent {
  render() {
    const { links, geoNames } = this.props;

    if (
      (!links.geo || !links.geo.length) &&
      (!links.geoHorizontal || !links.geoHorizontal.length) &&
      (!links.propertyType || !links.propertyType.length) &&
      (!links.similar || !links.similar.length)
    ) {
      return null;
    }

    const geoNameCities = geoNames
      ? {
          '%1$s': geoNames.city || geoNames.country,
          '%2$s': geoNames.city || geoNames.country,
          '%3$s': geoNames.city || geoNames.country,
        }
      : {};

    const geoNamePropertyType = geoNames
      ? { '%3$s': geoNames.cityArea || geoNames.city || geoNames.region || geoNames.country }
      : {};

    const cityTitle =
      (geoNames && geoNames.city && <FormattedMessage values={geoNameCities} {...closeTo} />) ||
      (geoNames && geoNames.country && (
        <FormattedMessage values={geoNameCities} {...citiesInRegion} />
      ));

    return (
      <div id="interlinking">
        {links.geo && (
          <InterlinkingBlock
            title={<FormattedMessage {...locationTitle} />}
            links={links.geo}
            dataTest="link-v"
          />
        )}

        {links.geoHorizontal && (
          <InterlinkingBlock title={cityTitle} links={links.geoHorizontal} dataTest="link-h" />
        )}

        {links.propertyType && (
          <InterlinkingBlock
            title={<FormattedMessage values={geoNamePropertyType} {...propertyTypesIn} />}
            links={links.propertyType}
            dataTest="link-ptype"
          />
        )}

        {links.similar && (
          <InterlinkingBlock
            title={<FormattedMessage {...similarSearches} />}
            links={links.similar}
            dataTest="link-sml"
          />
        )}
      </div>
    );
  }
}

InterlinkingHomes.defaultProps = {
  geoNames: null,
};

InterlinkingHomes.propTypes = {
  links: PropTypes.object.isRequired,
  geoNames: PropTypes.object,
};

export default InterlinkingHomes;
export { InterlinkingHomes as PureInterlinking };



// WEBPACK FOOTER //
// ./app/Serp/components/Interlinking/homes/index.js